import { useQueryClient } from '@tanstack/react-query';
import { Reorder } from 'framer-motion';
import { useEffect, useState } from 'react';
import { LuSaveAll } from 'react-icons/lu';
import { toast } from 'react-toastify';
import { useAuthContext } from '../../../contexts/AuthProvider';
import { useServiceContext } from '../../../contexts/ServiceProvider';
import useServiceActions from '../../../hooks/APIHooks/appointments/useServiceActions';
import { ReorderItem } from '../../../types/common';
import { ServiceReorder } from '../../../types/services';
import { fetchErrorMessage } from '../../../utils/fetchErrorMessage';
import AcademiaButton from '../Buttons/AcademiaButton';
import ReorderCard from '../Cards/ReorderCard';
import ModalTitle from './ModalTitle';
import ParentModal from './ParentModal';

const ChangeServicePopularityModal = ({
  handleModalClose,
}: {
  handleModalClose: () => void;
}) => {
  // integration of react hooks here
  const [popularServices, setPopularServices] = useState<Array<ReorderItem>>(
    []
  );

  const [isPopularityChanging, setIsPopularityChanging] =
    useState<boolean>(false);

  // integration of context hooks here
  const { serviceList } = useServiceContext();
  const { currentUser } = useAuthContext();

  // integration of custom API hooks here
  const { updateServicePopularityHandler } = useServiceActions('');

  // integration of tanstack query hooks here
  const queryClient = useQueryClient();

  // filtering popular services to change order here
  useEffect(() => {
    if (serviceList.length) {
      setPopularServices(
        serviceList.filter((service) => service.is_most_popular)
      );
    }
  }, [serviceList]);

  console.log('POPULAR: ', popularServices, serviceList);

  const ChangeServicePopularityHandler = async () => {
    try {
      setIsPopularityChanging(true);

      const body: Array<ServiceReorder> = popularServices.map(
        (service, index) => ({
          id: service.id,
          popular_order: index + 1,
          updated_by: currentUser?.username as string,
        })
      );

      await updateServicePopularityHandler
        .mutateAsync({ body })
        .then((res) => {
          if (res.is_success) {
            toast.success('Services Reordered!!');

            handleModalClose();
            queryClient.invalidateQueries({ queryKey: ['service-list'] });
          } else {
            toast.error(res.message || 'Service Reorder Failed!!');
          }
        })
        .catch((error) => toast.error(fetchErrorMessage(error)));
    } catch (error) {
      toast.error('Something Went Wrong!!');
    } finally {
      setIsPopularityChanging(false);
    }
  };

  // rendering change service popularity modal component here
  return (
    <ParentModal onClick={handleModalClose}>
      <ModalTitle titleText='change popularity' />

      <p className='text-base-orange font-semibold text-sm'>
        Drag Services Vertically To Change Popularity Order
      </p>

      <Reorder.Group
        axis='y'
        className='space-y-3'
        onReorder={setPopularServices}
        values={popularServices}
      >
        {popularServices.map((service, index) => (
          <ReorderCard key={service.id} item={service} index={index} />
        ))}
      </Reorder.Group>

      <AcademiaButton
        type='button'
        onClick={ChangeServicePopularityHandler}
        variant='premium'
        icon={<LuSaveAll className='size-6' />}
        isLoading={isPopularityChanging}
        fullWidth
      >
        Save
      </AcademiaButton>
    </ParentModal>
  );
};

export default ChangeServicePopularityModal;
